<template>
  <div class="multiUploadFile-container">
    <el-upload
      ref="multiUploadFile"
      :action="uploadFile"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :on-success="successMultiFile"
      :on-error="errorMultiFile"
      multiple
      :show-file-list="showList"
      :limit="limit"
      :on-exceed="handleExceed"
      :file-list="old">
      <span v-if="!oldSpan" slot="tip" class="el-upload__tip" style="color:#99a9bf;margin-right: 10px;float: left;margin-top: 10px;">上传文件大小不能超过 2GB</span>
      <el-button v-if="oldButton" size="small" icon="el-icon-upload2">点击上传</el-button>
      <el-button v-else size="medium" type="primary">点击上传</el-button>
      <span v-if="oldSpan" slot="tip" class="el-upload__tip" style="color:#99a9bf;margin-left: 10px">最多上传 {{limit}} 个文件，每个文件且不超过 2GB</span>
    </el-upload>
  </div>
</template>

<script>

export default {
  name: 'MultiFileJXS',
  props: {
    limit: {
      type: Number
    },
    old: {
      type: Array
    },
    showList: {
      type: Boolean,
      default: true
    },
    oldButton: {
      type: Boolean,
      default: true
    },
    oldSpan: {
      type: Boolean,
      default: true
    }
  },
  created() {
    if (this.old !== undefined) {
      if (this.old.length > 0) {
        for (let i of this.old) {
          this.fileids.push(i.id)
        }
        this.$emit('input', this.fileList)
      }
    }
  },
  data() {
    return {
      uploadFile: process.env.VUE_APP_BASE_API + '/fileUpload/uploadFile',
      fileids: [],
      filenames: []
    }
  },
  methods: {
    handleRemove(file, fileList) {
      if (file.response !== undefined && file.response.data !== null ) {
        const i = this.fileids.indexOf(file.response.data.dFileid)
        if (i !== -1) {
          this.fileids.splice(i, 1)
        }
      } else {
        if (file.id !== undefined && file.id !== null ) {
          const i = this.fileids.indexOf(file.id)
          if (i !== -1) {
            this.fileids.splice(i, 1)
          }
        }
      }
      this.$emit('input', this.fileids)
    },
    errorMultiFile() {
      this.$message({
        type: 'error',
        message: '文件上传失败，请稍后重试'
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name } ？`)
    },
    successMultiFile(response, file, fileList) {
      if (response.success) {
        console.log('response.data: ' + response.data.dName)
        this.fileids.push(response.data.dFileid)
        this.filenames.push(response.data.dName)
        this.$emit('input', this.fileids)
        this.$emit('nameList', response.data)
      } else {
        this.$message({
          type: 'error',
          message: response.msg
        })
      }
    },
    clearMultiFile() {
      this.fileids = []
      this.$emit('input', this.fileids)
      this.$refs['multiUploadFile'].clearFiles()
    }
  }
}
</script>

<style scoped>

</style>
